const NBSP = '‎';
export default NBSP;
